import styled from '@emotion/styled';
import { boxSizes } from '@gumtree/ui-library/src/base/theme';
import { Dialog } from '@gumtree/ui-library';


export const RequestAQuoteDialog = styled(Dialog)<{ app: boolean }>`
    padding: 0;
    border-radius: ${boxSizes.borderRadius8};
    display: flex;
    flex-wrap: wrap;

    .dialog-title {
        position: sticky;
        left: 0px;
        top: 0px;
        background: white;
        z-index: 5;
        padding-right: 0;
        margin-bottom: 0;
        width: 100%;
    }

    .dialog {
        height: ${({ app }) => app ? '100%' : '85%'};
        min-width: auto;
        width: 100%;

        .dialog-close {
            order: 2;
            background: transparent;
            position: absolute;
            border-radius: 0px;
            top: 0px;
            right: 0px;
            z-index: 6;

            .icon.icon--clear {
                top: 0px;
                right: 0px;
                transform: none;
            }
        }

    }

    .dialog-content {
        order: 3;
        width: 100%;
        height: calc(100% - 90px);
    }
`;
